import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PickersActionBar } from "@mui/x-date-pickers/PickersActionBar";
import dayjs from "dayjs";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { FieldWrapper } from "styles/formStyleComponents";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const DatePickerFieldComponent = ({
  name,
  label,
  placeholder,
  value,
  required,
  disabled,
  error,
  info,
  onChange,
  minDate,
  maxDate,
  format = "MM / DD / YYYY",
  popperProps,
  compact = false,
}) => {
  const fieldLabel = required ? `${label} *` : label;

  const getDateValue = (val) => {
    if (!val) return null;
    if (dayjs.isDayjs(val)) return val;
    return dayjs(val);
  };

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(name, newValue);
    }
  };

  const datePicker = (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={compact ? undefined : fieldLabel}
        value={getDateValue(value)}
        onChange={handleChange}
        minDate={minDate ? getDateValue(minDate) : undefined}
        maxDate={maxDate ? getDateValue(maxDate) : undefined}
        disabled={disabled}
        slotProps={{
          textField: {
            placeholder: placeholder || "mm / dd / yyyy",
            fullWidth: true,
            error: !!error,
            helperText: error,
            size: "small",
            variant: "outlined",
            autoComplete: "off",
            ...(info && {
              InputProps: {
                endAdornment: <InfoIconWithTooltip info={info} />,
              },
            }),
          },
          popper: popperProps || {},
          actionBar: { actions: ["clear", "today"] },
        }}
        slots={{
          openPickerIcon: CalendarTodayIcon,
          actionBar: PickersActionBar,
        }}
        format={format}
      />
    </LocalizationProvider>
  );

  if (compact) {
    return datePicker;
  }

  return (
    <FieldWrapper>
      {datePicker}
    </FieldWrapper>
  );
};

export default DatePickerFieldComponent;

